var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"d-flex justify-content-start"},[_c('div',{staticClass:"app-body w-100"},[_c('Router')],1)]),_c('sign-up-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }